export var AlarmDataSourceType;
(function (AlarmDataSourceType) {
    AlarmDataSourceType[AlarmDataSourceType["Variable"] = 0] = "Variable";
    AlarmDataSourceType[AlarmDataSourceType["FBox"] = 1] = "FBox";
})(AlarmDataSourceType || (AlarmDataSourceType = {}));
